import React from 'react';
import { Pagination, Container } from 'react-bootstrap';
import env from '../../env';


const PaginationComponent = (props) => {

    const totalResults = props.totalResults;
    const currentPage = props.currentPage;
    const setCurrentPage = props.setCurrentPage;
    const scrollToTop= props.scrollToTop;
    const pageSize = props.pageSize || env.PAGE_SIZE || 21;

    const totalPages = Math.ceil(totalResults / pageSize);

    const getPaginationItems = () => {
        const items = [];

        if (currentPage > 3) {
            items.push(
                <Pagination.Item key={1} onClick={() => {setCurrentPage(1); scrollToTop();}}>
                    {1}
                </Pagination.Item>
            );
            if (currentPage > 4) {
                items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
            }
        }

        for (let number = Math.max(1, currentPage - 2); number <= Math.min(totalPages, currentPage + 2); number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => {setCurrentPage(number); scrollToTop();}}
                >
                    {number}
                </Pagination.Item>
            );
        }

        if (currentPage < totalPages - 2) {
            if (currentPage < totalPages - 3) {
                items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
            }
            items.push(
                <Pagination.Item key={totalPages} onClick={() => {setCurrentPage(totalPages); scrollToTop();}}>
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    };

    return (
        <Container className="mt-5">
            <div className="d-flex justify-content-center">
                <Pagination className="custom-pagination">
                    <Pagination.First onClick={() => {setCurrentPage(1); scrollToTop();}} disabled={currentPage === 1} className="d-none d-sm-inline" />
                    <Pagination.Prev onClick={() => {setCurrentPage(prev => Math.max(prev - 1, 1)); scrollToTop();}} disabled={currentPage === 1} />

                    {getPaginationItems()}

                    <Pagination.Next onClick={() => {setCurrentPage(prev => Math.min(prev + 1, totalPages)); scrollToTop()}} disabled={currentPage === totalPages} />
                    <Pagination.Last onClick={() => {setCurrentPage(totalPages); scrollToTop();}} disabled={currentPage === totalPages} className="d-none d-sm-inline" />
                </Pagination>
            </div>
        </Container>
    );

}

export default PaginationComponent;